// Enter key is disabled from triggering a PDF export
const VisualStatic = require('visual-static');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

    this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();

    // Set the correct order of fields
    VisualStatic.setTabOrder(this.orderOfFormFields);

    // Remove labels (they are basically duplicates)
    VisualStatic.setPlaceholders(this.removeLabelsFromFields);

    // Hide the eFiling option for the 2014 tax returns
    if (!window.SessionManager.isPaidUser) {
      document.getElementById('group_efiling_subheading').style.display = 'none';
      document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
      document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
      document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

      // group_efiling_subheading is not displayed, which affects positioning of country fields
      document.getElementById('group_payee1_country').style.top = '-3042px';
      document.getElementById('group_payer_country').style.top = '-3355px';
    }

    // Disables default dropdown option for W2 additional fields:
    // payee1_employment_type and payer_kind_of_employer
    VisualStatic.disableW2SelectDefaultOption();

    VisualStatic.initExportPDF();
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-w2-efile-2016.js